export const SSO_LOGIN_METHODS = {
  azure: 'azure',
  google: 'google',
} as const;
